import { render } from "./WorkspaceCard.vue?vue&type=template&id=10c2d607"
import script from "./WorkspaceCard.vue?vue&type=script&lang=js"
export * from "./WorkspaceCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/settings/Cards/WorkspaceCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10c2d607"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10c2d607', __exports__)) {
    api.reload('10c2d607', __exports__)
  }
  
  module.hot.accept("./WorkspaceCard.vue?vue&type=template&id=10c2d607", () => {
    api.rerender('10c2d607', render)
  })

}


export default __exports__